function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.861 14.603l-.02-6.349H.301v-2.54h2.54V4.127c0-2.356 1.46-3.492 3.562-3.492 1.007 0 1.872.075 2.124.108v2.463H7.07c-1.143 0-1.364.544-1.364 1.341v1.167h3.327l-1.27 2.54H5.705v6.35H2.86z",
  fill: "#FFF"
});

var SvgFacebookLogo = function SvgFacebookLogo(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 9 15"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,Cjxzdmcgdmlld0JveD0iMCAwIDkgMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTIuODYxIDE0LjYwM2wtLjAyLTYuMzQ5SC4zMDF2LTIuNTRoMi41NFY0LjEyN2MwLTIuMzU2IDEuNDYtMy40OTIgMy41NjItMy40OTIgMS4wMDcgMCAxLjg3Mi4wNzUgMi4xMjQuMTA4djIuNDYzSDcuMDdjLTEuMTQzIDAtMS4zNjQuNTQ0LTEuMzY0IDEuMzQxdjEuMTY3aDMuMzI3bC0xLjI3IDIuNTRINS43MDV2Ni4zNUgyLjg2eiIgZmlsbD0iI0ZGRiIgZmlsbC1ydWxlPSJub256ZXJvIi8+PC9zdmc+";
export { SvgFacebookLogo as ReactComponent };